module.exports = {"title":"Használati feltételek","short":{"sympa":{"text":"Kedves emberek vagyunk:"}}};